import MDBox from "components/MDBox";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default function data(apiData = [], onEdit, onDelete) {
  return {
    columns: [
      { Header: "Property Name", accessor: "title", align: "left" },
      { Header: "Price", accessor: "price", align: "left" },
      { Header: "Area (sqft)", accessor: "area_sqft", align: "left" },
      { Header: "Bedrooms", accessor: "bedrooms", align: "left" },
      { Header: "Bathrooms", accessor: "bathrooms", align: "left" },
      { Header: "Action", accessor: "action", align: "center" },
    ],

    rows: apiData.map((item) => ({
      title: item.title ?? "-",
      price: `₹${item.price ?? "-"}`,
      area_sqft: `${item.area_sqft ?? "-"} sqft`,
      bedrooms: item.bedrooms ?? "-",
      bathrooms: item.bathrooms ?? "-",
      action: (
        <MDBox display="flex" justifyContent="center" gap={1}>
          <IconButton
            size="small"
            color="primary"
            onClick={(e) => {
              e.preventDefault();
              onEdit(item);
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            color="error"
            onClick={(e) => {
              e.preventDefault();
              onDelete(item);
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
